import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "../../styles";
import styles from "../links/Link/Link.module.css";

export const externalLinkIcon = style({
  flexShrink: 0,
  width: "1em",
  height: "1em",
});

export const rtlArrowIconStyles = style({
  selectors: {
    '[dir="rtl"] &': {
      transform: "scaleX(-1)",
    },
  },
});

export const moreLinkStyles = styleVariants({
  default: [
    styles.link,
    {
      justifyContent: "space-between",
      display: "inline-flex",
      alignItems: "center",
    },
  ],
  light: [
    styles.link,
    {
      fontFamily: vars.fonts.regular,
      width: "fit-content",
      display: "inline-flex",
      alignItems: "center",
    },
  ],
});
